"use client";

import { useMutation } from "@tanstack/react-query";
import type { UpdatePrintSettingsRequest } from "@/generated/fastapi";
import { useAuth } from "@/state/globalStore";
import { updatePrintSettings } from "../api/updatePrintSettings";

export default function useUpdatePrintSettingsMutation() {
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (request: UpdatePrintSettingsRequest) =>
      updatePrintSettings(accessToken, request),
  });
}
